import localStorageUtil from '@/common/utils/localStorageUtil';
import Constant from '@/common/constant/Constant';
import { createNewTicketAPI, saveDraftTicketAPI, deleteAllTicketData } from '@/service/ticketService';
import Utils from '@/common/utils/utils';
import { handleUploadFilesForTicket, copyFileOfTicketDraftTo } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import { I18n } from 'aws-amplify';
import { removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import { getFormListByProject } from '@/service/formManagementService';
import {sortListByOrder} from './TicketHandler';
import { TmpHiddenSysFieldInTicketDetail } from '@/common/constant/SystemField';
import { createKibanaDataContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import { updateUserWorkLastForm } from '@/common/utils/ServiceFactoryUtil';

export const onSubmitCreateEscalateTicket = async (
    argsAll,
    ticketStatus,
    formData,
    fieldListData
) => {
    argsAll.setIsLoading(true);
    
    let requestBody = {};
    const affiliationOrganization = formData.corporationTarget;
    const affiliationProject = formData.projectTarget;
    const customer = localStorageUtil.getSelectedProjectId();
    let status = '';
    const statusField = fieldListData.find(fieldData => fieldData.type === 'WORKFLOW');
    if (!Utils.isEmptyObject(statusField)) {
        status = statusField.fieldId;
    }
    const fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData);

   const uploadFileS3Result =  await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll?.fileUpdatedList),
        // oldDraftTicketId: argsAll?.ticketDetail?.id ? argsAll?.ticketDetail?.id : ''
    };

    requestBody = {
        createTicketRequestDto: {
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public:
                ticketStatus === Constant.QA_FILTER_STATUS.DRAFT
                    ? Constant.TICKET_PUBLIC.DRAFT
                    : Constant.TICKET_PUBLIC.PUBLIC,
            outline: formData.outline,
            corporationOrigin: argsAll.corporationDetail.id,
            description: formData.description,
            createUserId: argsAll.userDetail.id,
            type: formData?.selectedForm,
            projectOrigin: localStorageUtil.getSelectedProjectId(),
            projectTarget: [formData.projectTarget],
            corporationTarget: formData.corporationTarget,
            ticketType: Constant.TICKET_TYPE.ESCALATION,
            customerReferenceThreadId: argsAll.customerThread,
            parentTicket: argsAll.ticketIdSelected,
            referenceInternalThreadId: argsAll.internalThread,
            ticketParentShareFlag: argsAll.isEnableShareTicketParent ? 1 : 0,
            customerThreadShareFlag: argsAll.isEnableShareCustomerThread ? 1 : 0,
            affiliationOrganization,
            affiliationProject,
            fields,
            status,
            customer,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            ...draftTicketInfo
        }
    };
    const newTicket = await createNewTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        if (
            !newTicket.createTicketStatus &&
            newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR
        ) {
            // Reload
            argsAll.setIsOpenModalReloadPage(true);
        }
        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_QA,
        formId: formData?.selectedForm,
        projectTargetId: formData.projectTarget,
        corpTargetId: formData.corporationTarget ? formData.corporationTarget : argsAll.corporationDetail.id
    }
    await updateUserWorkLastForm(dataUpdateLastForm, argsAll?.setUserDetail, argsAll.userDetail);

    let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    let dataLog = {
        rootCorporationDetail: {
            id: argsAll.corporationTarget
        },
        rootProjectDetail: {
            id: argsAll.projectTarget
        },
        corporationDetail: argsAll.corporationDetail,
        projectDetail: argsAll.projectDetail,
        userDetail: argsAll.userDetail,
        ticketDetail: {
            id: newTicket.id,
            outline: newTicket.outline,
            creator: newTicket.creator,
            usingFormName: usingFormName,
            createdAt: newTicket.createdAt,
            isEscalation: true,
            parent: {
                id: argsAll.ticketDetail.id,
                outline: argsAll.ticketDetail.outline
            }
        },
        metaData: {
            formDetailId: argsAll.selectedForm,
            ticketType: Constant.TICKET_TYPE.QA
        },
        ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    }

    let logKibanaData = createKibanaDataContentOperation(
        lastUserAction,
        dataLog
    );
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
        logKibanaData: logKibanaData
    };
    createKibanaLogAPI(argsAll.API, param);
    argsAll.setLastUserAction(null);
    if (argsAll?.draftTicketData) {
        //namnh TODO: not remove, need update ticket
        await removeDraftTicket(argsAll);
    }
    argsAll.setIsLoading(false);
    argsAll.enqueueSnackbar(I18n.get('MSG-CM-SEND-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    removePanelInitData(argsAll.panelId, argsAll.tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    argsAll.updatePanelAfterCreateTicket({
        panelId: argsAll.panelId,
        tabId: argsAll.tabId,
        panelType: argsAll.panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        API: argsAll.API
    });

    argsAll.reloadHelpdeskTicketByCreateEscalateTicket({
        panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
        parentTicketId: argsAll.ticketIdSelected
    });

    argsAll.setReload(Date.now().toString());

    return;
};

export const onSubmitSaveDraftEscalateTicket = async (
    argsAll,
    formData,
    panelId,
    panelType,
    tabId
) => {
    argsAll.setIsLoading(true);

    let requestBody = {};
    const affiliationOrganization = formData.corporationTarget;
    const affiliationProject = formData.projectTarget;
    const customer = localStorageUtil.getSelectedProjectId();
    let status = '';
    const statusField = argsAll.fieldListData.find(fieldData => fieldData.type === 'WORKFLOW');
    if (!Utils.isEmptyObject(statusField)) {
        status = statusField.fieldId;
    }
    const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);

    const uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );

    requestBody = {
        createTicketRequestDto: {
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.DRAFT,
            outline: formData.outline,
            corporationOrigin: argsAll.corporationDetail.id,
            description: formData.description,
            createUserId: argsAll.userDetail.id,
            type: formData?.selectedForm,
            projectOrigin: localStorageUtil.getSelectedProjectId(),
            projectTarget: [formData.projectTarget],
            corporationTarget: formData.corporationTarget,
            ticketType: Constant.TICKET_TYPE.ESCALATION,
            customerReferenceThreadId: argsAll.customerThread,
            parentTicket: argsAll.ticketIdSelected,
            referenceInternalThreadId: argsAll.internalThread,
            ticketParentShareFlag: argsAll.isEnableShareTicketParent ? 1 : 0,
            customerThreadShareFlag: argsAll.isEnableShareCustomerThread ? 1 : 0,
            affiliationOrganization,
            affiliationProject,
            fields,
            status,
            customer,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments)

        }
    };
    const newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        if (
            !newTicket.createTicketStatus &&
            newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR
        ) {
            // Reload
            argsAll.setIsOpenModalReloadPage(true);
        }
        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_QA,
        formId: formData?.selectedForm,
        projectTargetId: formData.projectTarget,
        corpTargetId: formData.corporationTarget ? formData.corporationTarget : argsAll.corporationDetail.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll?.setUserDetail, argsAll.userDetail);

    // let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    // let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    // let dataLog = {
    //     rootCorporationDetail: {
    //         id: argsAll.corporationDetail.id
    //     },
    //     rootProjectDetail: {
    //         id: argsAll.projectDetail.id
    //     },
    //     corporationDetail: argsAll.corporationDetail,
    //     projectDetail: argsAll.projectDetail,
    //     userDetail: argsAll.userDetail,
    //     ticketDetail: {
    //         id: newTicket.id,
    //         outline: newTicket.outline,
    //         creator: newTicket.creator,
    //         usingFormName: usingFormName,
    //         createdAt: newTicket.createdAt,
    //         isEscalation: true,
    //         parent: {
    //             id: argsAll.ticketDetail.id,
    //             outline: argsAll.ticketDetail.outline
    //         }
    //     },
    //     metaData: {
    //         formDetailId: argsAll.selectedForm,
    //         ticketType: Constant.TICKET_TYPE.QA
    //     },
    //     ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    // }

    // let logKibanaData = createKibanaDataContentOperation(
    //     lastUserAction,
    //     dataLog
    // );
    // let param = {
    //     logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
    //     logKibanaData: logKibanaData
    // };
    // createKibanaLogAPI(argsAll.API, param);
    // argsAll.setLastUserAction(null);
    if (argsAll?.draftTicketData) {
        //namnh TODO: not remove, need update ticket
        await removeDraftTicket(argsAll);
    }
    argsAll.enqueueSnackbar(I18n.get('MSG-CM-SAVE-DRAFT-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });

    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        API: argsAll.API,
        isDraft: true
    });
    return;
};

export const removeDraftTicket = async (argsAll) => {
    if (argsAll?.draftTicketData) {
        await deleteAllTicketData(argsAll.API, {
            ticketId: argsAll.draftTicketData.detailTicket.id
        }); 
    }
}

/**
 * initDataPanelCreateTicketEscalate
 * @param {*} currentPanelInitDataRes 
 * @param {*} argsAll 
 */
export const initDataPanelCreateTicketEscalate = (currentPanelInitDataRes, argsAll) => {
    let oldArgsAll = currentPanelInitDataRes.argsAll;

    // File upload
    let fileUploadListOld = oldArgsAll.fileUploadList;
    if (!Utils.isEmptyArray(fileUploadListOld)) {
        argsAll.setFileUploadList(fileUploadListOld);
        argsAll.setValueCreateQaTicket(
            'fileUploadList',
            fileUploadListOld
        );
    }

    if (oldArgsAll.listProjectDeskOn && !Utils.isEmptyArray(oldArgsAll.listProjectDeskOn)) {
        argsAll.setListProjectDeskOn(oldArgsAll.listProjectDeskOn);
    }
    if (oldArgsAll.projectTarget) {
        argsAll.setProjectTarget(oldArgsAll.projectTarget);
        argsAll.setValueCreateEscalateTicket(
            'projectTarget',
            oldArgsAll.projectTarget
        );
    }
    if (oldArgsAll.corporationTarget) {
        argsAll.setCorporationTarget(oldArgsAll.corporationTarget);
        argsAll.setValueCreateEscalateTicket(
            'corporationTarget',
            oldArgsAll.corporationTarget
        );
    }
    if (oldArgsAll.formList && !Utils.isEmptyArray(oldArgsAll.formList)) {
        argsAll.setFormList(oldArgsAll.formList);
    }
    if (oldArgsAll.selectedForm) {
        argsAll.setSelectedForm(oldArgsAll.selectedForm);
        argsAll.setValueCreateEscalateTicket('selectedForm', oldArgsAll.selectedForm);
    }
    if (oldArgsAll.fieldListData && !Utils.isEmptyArray(oldArgsAll.fieldListData)) {
        argsAll.setFiledListData(oldArgsAll.fieldListData);
    }
    argsAll.setIsEnableShareCustomerThread(oldArgsAll.isEnableShareCustomerThread ? oldArgsAll.isEnableShareCustomerThread : false);
    argsAll.setIsEnableShareTicketParent(oldArgsAll.isEnableShareTicketParent ? oldArgsAll.isEnableShareTicketParent : false);
}

/**
 * init data from draft data
 * @param {*} draftData 
 * @param {*} argsAll 
 */
 export const initDataFromDrafTicket = async (argsAll) => {
    const draftData = argsAll.draftTicketData;
    const detailDraftTicket = draftData.detailTicket;
    if (!Utils.isEmptyObject(detailDraftTicket?.customersCustomer)) {
        const customerObject = Utils.convertJSONDataToObject(detailDraftTicket.customersCustomer);
        if (customerObject?.referenceThread) {
            argsAll.setIsEnableShareCustomerThread(true);
        }
        if (customerObject?.ticketQA) {
            argsAll.setIsEnableShareTicketParent(true);
        }
    }
    // project target 
    let projectTarget = !Utils.isEmptyArray(detailDraftTicket.projectTarget) ? detailDraftTicket.projectTarget[0] : '';
    if (projectTarget) {
        argsAll.setProjectTarget(projectTarget);
        argsAll.setValueCreateEscalateTicket('projectTarget', projectTarget);
        const selectedHelpDeskProjectDetail = argsAll.draftListProjectDeskOn.find(
            project => project.id === projectTarget
        );
        argsAll.setValueCreateEscalateTicket(
            'corporationTarget',
            selectedHelpDeskProjectDetail.affiliationOrganization
        );
        argsAll.setCorporationTarget(selectedHelpDeskProjectDetail.affiliationOrganization);
        const formOfProjectList = await getFormListByProject(
            argsAll.API,
            selectedHelpDeskProjectDetail.affiliationOrganization,
            projectTarget
        );

        let listFormQaOfProject = formOfProjectList.filter(
            form => form.type === Constant.FORM_TYPE.FORM_REQ_QA
        );
        listFormQaOfProject = sortListByOrder(listFormQaOfProject, projectTarget);

        argsAll.setFormList(listFormQaOfProject);

        let formDetail = Utils.convertJSONDataToObject(draftData.formDetail);
        const formId = formDetail.id;

        await argsAll.handleOnchangeForm(formId);

        setFormDataDraftTicketDetail(draftData, argsAll);
    }
}

const setFormDataDraftTicketDetail = (draftData, argsAll) => {
    let fieldListData = Utils.convertJSONDataToObject(draftData.fieldListData);
    let cloneCurrentPanelInitData = {...argsAll.currentPanelInitData};
    let objFormData = cloneCurrentPanelInitData?.formData && !Utils.isEmptyObject(cloneCurrentPanelInitData?.formData) ? cloneCurrentPanelInitData?.formData : {};
    if (!Utils.isEmptyArray(fieldListData)) {
        fieldListData.forEach(field => {
            if (!TmpHiddenSysFieldInTicketDetail.includes(field.sysField)) {
                if (field.type === Constant.FORM_TYPE.FIELD_TAG) {
                    let defaultSelectedTag = [];
                    if (!Utils.isEmpty(field?.defaultValue)) {
                        defaultSelectedTag = field.defaultValue;
                    }
                    objFormData[field.id] = defaultSelectedTag;
                } else {
                    objFormData[field.id] = field.value;
                }
            }            
        });
        cloneCurrentPanelInitData.formData = objFormData;
        argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
    }
}
